// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

import * as bootstrap from "bootstrap"
window.bootstrap = bootstrap

import TablesHelper from "./widgets/tables_helper"
window.tables = new TablesHelper()

import { Chart } from 'chart.js'

import { Colors } from 'chart.js'
Chart.register(Colors)

import "./widgets/disable_on_submit"
import "./widgets/hide_popper_on_turbo_cache"
import "./widgets/modals"
import "./widgets/remove_turbo_frame_loading_attr_before_cache"
import "./widgets/show_turbo_modal_on_error"
import "./widgets/toasts"
import "./widgets/tooltips"
